import { render, staticRenderFns } from "./AddProductDataOther.vue?vue&type=template&id=53fe8204&scoped=true"
import script from "./AddProductDataOther.vue?vue&type=script&lang=js"
export * from "./AddProductDataOther.vue?vue&type=script&lang=js"
import style0 from "./AddProductDataOther.vue?vue&type=style&index=0&id=53fe8204&prod&lang=less"
import style1 from "./AddProductDataOther.vue?vue&type=style&index=1&id=53fe8204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe8204",
  null
  
)

export default component.exports